<template>
  <section class="block">
    <div class="container container--max-desktop">
      <div class="page-content text-center">
        <h2>There was a problem fetching results</h2>
        <p>Please try again by refreshing the page.</p>
        <hr />
      </div>
    </div>
  </section>
</template>
